import {Component, computed} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UserService} from '../../../shared/services/user.service';
import {DAILY_REWARDS, Reward} from '../../../shared/constants/rewards.constant';

@Component({
  selector: 'app-daily-rewards',
  imports: [CommonModule],
  templateUrl: './daily-rewards.component.html',
  styleUrl: './daily-rewards.component.scss'
})
export class DailyRewardsComponent {
  currentDay = computed(() => this.userService.userProfile()?.streakDays ?? 1);
  rewards: Reward[] = DAILY_REWARDS;
  lastDay = this.rewards.length;


  constructor(private userService: UserService) {
  }
}
